export const user = {
  chineseSimplified: "中文（简体）",
  chineseTraditional: "中文（繁体）",
  companyAddress: "公司地址",
  companyName: "公司名称",
  confirmPassword: "确认密码",
  countryRegion: "地区",
  DDMMYYYY: "DD-MM-YYYY",
  email: "邮箱",
  emergencyContact: "紧急联系人",
  emergencyContactNumber: "紧急联系人电话",
  employeeNumber: "员工编号",
  english: "英语",
  failedToDeleteUserLastAdminFailed: "删除失败，至少要保留一个管理员账号。",
  failedToNFCCardIDAlreadyExist: "保存失败，此NFC卡号已存在。",
  failedToSaveChangeRoleLastAdminFailed:
    "修改角色失败，至少要保留一个管理员账号。",
  failedToSaveEmailAlreadyExist: "保存失败，此邮箱已存在。",
  failedToSaveEmailInvalid: "保存失败，此邮箱不合法。",
  failedToSaveEmployeeNumberAlreadyExist: "保存失败，此员工编号已存在。",
  failedToSavePhoneNumberAlreadyExist: "保存失败，此手机号已存在。",
  failedToSaveRegistrationQuotaReached: "无法新增账号，注册额度已用完。",
  failedToSaveUploadPhotoFailed: "保存失败，图片未上传。",
  firstName: "名",
  fleet: "车间",
  french: "法语",
  german: "德语",
  italian: "意大利语",
  japanese: "日语",
  lastName: "姓",
  MMDDYYYY: "MM-DD-YYYY",
  name: "姓名",
  nextCycleScheduleDeleteUserTips:
    "已超过下一个账单周期的用户注册额度。此账号将于本次账单周期结束时被删除。您可以在“计划”页面修改将要被删除的账号。",
  notValidEmailAddress: "邮件地址不合法",
  password: "密码",
  phoneNumber: "手机号",
  department: "部门",
  photo: "照片",
  pleaseInputCompanyAddress: "请输入公司地址",
  pleaseInputCompanyName: "请输入公司名称",
  pleaseInputEmail: "请输入邮箱",
  pleaseInputFirstName: "请输入名",
  pleaseInputLastName: "请输入姓",
  pleaseInputName: "请输入姓名",
  pleaseInputPassword: "请输入密码",
  pleaseInputPhoneNumber: "请输入手机号",
  pleaseSelectDepartment: "请选择部门",
  pleaseInputZIPCode: "请输入邮编",
  pleaseSelectRole: "请选择角色",
  selectDepartmentAlreadyExit: "已经存在部门【{0}】",
  selectDepartmentUpgrade: "【{0}】将升级为【{1}】",
  portalLanguage: "网站语言",
  role: "角色",
  sendSuccessfully: "已发送",
  spanishes: "西班牙语",
  status: "状态",
  timeFormat: "时间格式",
  timeZone: "时区",
  unitOfMeasure: "计量单位",
  YYYYMMDD: "YYYY-MM-DD",
  ZIPCode: "邮编",
  pleaseInputCertExpireTime: "请输入驾照过期时间",
  userImport: "用户导入",
  search: "检索",
  userSearchLimit: "至少输入1个汉字",
  mobileSearchLimit: "至少输入3位数字",
  empNoSearchLimit: "至少输入2位字符",
  pleaseInputEmployNumber: "请输入员工编号",
  pleaseInputEmergencyContact: "请输入紧急联系人",
  pleaseInputEmergencyContactNumber: "请输入紧急联系人电话",
  failedToSaveDriverPhotoNotHasFRFeature:
    "保存失败，司机照片不是面部识别照片。",
};
